import { render, staticRenderFns } from "./ConfigurazioneDevicePage.vue?vue&type=template&id=67f7a61a"
import script from "./ConfigurazioneDevicePage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneDevicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports